import React from 'react';
import classNames from 'classnames';
import Point from './Point';
import { getScaleX, getScaleY } from '../utils';
var PointChart = function (_a) {
    var chartId = _a.chartId, width = _a.width, height = _a.height, _b = _a.data, data = _b === void 0 ? [] : _b, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, hovered = _a.hovered, pointClassName = _a.pointClassName, scaleX = _a.scaleX, scaleY = _a.scaleY, pointSize = _a.pointSize;
    var pointData = data.map(function (d) { return d.point; });
    var x = scaleX || getScaleX(width, pointData);
    var y = scaleY || getScaleY(height, pointData);
    var points = data.map(function (d, i) { return (d.point[1] !== undefined && (React.createElement(Point, { id: i, key: i, x: x(d.point[0] !== undefined ? d.point[0] : i), y: y(d.point[1]), size: pointSize, className: classNames(pointClassName, d.className), onMouseOver: onMouseOver, onMouseOut: onMouseOut, hovered: hovered === i }))); });
    return React.createElement("svg", { id: chartId, width: width, height: height }, points);
};
export default PointChart;
//# sourceMappingURL=PointChart.js.map